import clsx from 'clsx';
import React, { PropsWithChildren, ReactNode } from 'react';

import { CloseIcon } from 'static/images';
import styled from 'types/AppTheme';

import styles from './Modal.module.scss';

interface IModalContentWrapperProps {
  onClose: () => void;
  modalIcon?: ReactNode;
  wrapperClassName?: string;
}

const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 58px;
  min-height: 58px;
  background-color: ${({ theme }) => theme.colors.brandColor};
  border-radius: 50%;

  & > svg {
    stroke: ${({ theme }) => theme.colors.brandColor};
  }
`;

const ModalContentWrapper = ({
  children,
  onClose,
  modalIcon,
  wrapperClassName,
}: PropsWithChildren<IModalContentWrapperProps>) => {
  return (
    <div
      className={clsx(styles.modalContent, wrapperClassName)}
      onClick={(e) => e.stopPropagation()}
    >
      <button onClick={onClose}>
        <CloseIcon className={styles.closeIcon} />
      </button>
      {modalIcon && (
        <div className={styles.contentHeader}>
          <div className={styles.modalImageWrapper}>
            <StyledIconWrapper>{modalIcon}</StyledIconWrapper>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default ModalContentWrapper;
